<template>
    <div>
        <h1>Einstellungen</h1>
        <br/>

        <fieldset>
            <legend>API</legend>
            <b>Dokumentation</b><br/>
            <a style="color: black;" target="_blank" href="https://documenter.getpostman.com/view/16866186/UVXesdk6">https://documenter.getpostman.com/view/16866186/UVXesdk6</a>
<br/>
<br/>            <b>Access Token</b>
            <p style="width: 600px; word-wrap: auto;word-break: break-all; font: 10pt Courier New;">{{ this.$store.getters.accessToken}}</p>
        </fieldset>

    </div>
</template>
<script>
export default({
    params: [],
    mounted() {
        this.spDelay = this.$store.getters.ScreeningPortalDelay;
    },
    methods: {
        testScreeningPortalLogin() {
            this.$emit("LoadingScreen", true)
            this.scrSuccess = false;
            this.scrError = false;
            this.$store.dispatch('enableScreeningPortal',{
                user: this.scrUser,
                pass: this.scrPass,
            })
            .then((user) => {
                this.apoName = user;
                this.$emit("LoadingScreen", false)
                this.scrSuccess = true;
                this.scrError = false;
            })
            .catch(() => {
                this.$emit("LoadingScreen", false);
                this.scrError = true;
                this.scrSuccess = false;
            })
        }
    },
    data() {
        return {
            scrError: false,
            scrSuccess: false,
            apoName: false,
            scrUser: "",
            scrPass: "",
            spDelay: 1,
            spDelayOpts: [
                { "id": 1, "value": 1, "name": '2-3h' },
                { "id": 2, "value": 2, "name": '4-8h' },
                { "id": 3, "value": 3, "name": '9-12h' },
                { "id": 4, "value": 4, "name": '13-17h' },
                { "id": 5, "value": 5, "name": '18-22h' },                
            ]
        }
    }
})
</script>

<style>
fieldset {
    border: 1px solid gray;
}
fieldset legend {
    padding-left: 15px;
    padding-right: 15px;
    font-weight: bold;
}
fieldset select {
    width: 200px;
}
</style>